import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@src/redux/store';
import { Project } from '@src/types/project';
import { getProjectsList } from './projectsThunk';

export type SearchByType = 'name' | 'brandKo' | 'brandEn' | 'company.name';
export interface ProjectsMetaDto {
  totalItems?: number;
  totalPages?: number;
}

export interface ProjectListParams {
  page?: number;
  limit?: number;
  sortBy?: string[];
  searchBy?: SearchByType;
  search?: string;
  filter?: any;
}
export interface ProjectsState {
  brandKo: string;
  brandEn: string;
  name: string;
  type: string;
  productName: string;
  status: string;
  shippingStatus: string;
  createdAt: string;
}
interface InitialState {
  loading: boolean;
  companyProjects: ProjectsState[];
  meta: ProjectsMetaDto;
  params: ProjectListParams;
}

const initialState: InitialState = {
  loading: false,
  companyProjects: [
    {
      brandEn: '',
      brandKo: '',
      name: '',
      type: '',
      productName: '',

      status: '',
      shippingStatus: '',
      createdAt: '',
    },
  ],
  meta: {
    totalItems: 1,
    totalPages: 1,
  },
  params: {
    page: 1,
    limit: 100,
    sortBy: [''],
    searchBy: 'name',
    search: '',
    filter: {
      companyId: 0,
    },
  },
};

const projectsSlice = createSlice({
  name: 'companyProjects',
  initialState,
  reducers: {
    onChangePageNum(state, { payload }) {
      state.params.page = payload + 1;
    },
    onChangeLimit(state, { payload }) {
      state.params.limit = payload;
    },
    onChangeSearchBy(state, { payload }) {
      state.params.searchBy = payload;
    },
    onChangeSearch(state, { payload }) {
      state.params.search = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectsList.fulfilled, (state, { payload }) => {
      state.companyProjects = payload.data.map((project: Project) => {
        const {
          brandEn,
          brandKo,
          name,
          type,
          productName,
          status,
          shippingStatus,
          createdAt,
          company,
          id,
        } = project;
        return {
          id,
          brandEn,
          brandKo,
          name,
          type,
          productName,
          status,
          shippingStatus,
          createdAt,
          company,
        };
      });
    });
  },
});

export const {
  onChangePageNum,
  onChangeLimit,
  onChangeSearch,
  onChangeSearchBy,
} = projectsSlice.actions;

export default projectsSlice.reducer;

const selfSelector = (state: RootState) => state.companyProjects;

export const companyProjectsSelector = createDraftSafeSelector(
  selfSelector,
  (companyProjectsState) => companyProjectsState
);
